"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatCourseMemberCompletions = exports.downsampleBuffer = exports.domainPattern = exports.convertToAlphanumeric = exports.containsInvalidSymbols = exports.checkIsGeneratedEmail = exports.capitalize = exports.calcTopicCompletions = exports.calcPercentageCompletion = exports.calcCompletions = void 0;
exports.formatCurrency = formatCurrency;
exports.formatNumberTotal = exports.formatMarkdownNewlines = exports.formatFileSize = void 0;
exports.getBase64ImageFromUrl = getBase64ImageFromUrl;
exports.markdownLinkRegex = exports.markdownImageLinkRegex = exports.localeCompareCase = exports.localeCompare = exports.jsonToRivescript = exports.getScoreValues = exports.getMicrophoneInfo = exports.getMachineInfo = exports.getBrowserInfo = void 0;
exports.moveDecimal = moveDecimal;
exports.searchStringToObj = exports.rivescriptToJson = exports.replaceWordWithBlank = exports.removeSymbols = exports.removeExtraWhiteSpaces = exports.removeAllSymbolsFillInBlanks = exports.removeAllSymbols = exports.randomId = exports.propsAreEqual = exports.objToSearchString = exports.multipleOptionsRegex = void 0;
exports.shuffle = shuffle;
exports.validateDomain = exports.supportsAudioType = void 0;
var _deepEqual = _interopRequireDefault(require("deep-equal"));
var _currencyCodeMap = _interopRequireDefault(require("./currency-code-map.json"));
var _rivescript = _interopRequireDefault(require("rivescript"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable no-useless-escape, no-plusplus */

const capitalize = (text = "") => text.charAt(0).toUpperCase() + text.slice(1);
exports.capitalize = capitalize;
const convertToAlphanumeric = (str = "") => str.trim().replace(/[^a-zA-Z0-9 ]/g, "");
exports.convertToAlphanumeric = convertToAlphanumeric;
const markdownLinkRegex = exports.markdownLinkRegex = /\[(.*)\]\(([^ ]+?)( "(.+)")?\)/;
const markdownImageLinkRegex = exports.markdownImageLinkRegex = /!\[(.*)\]\(([^ ]+?)( "(.+)")?\)/;
const multipleOptionsRegex = exports.multipleOptionsRegex = /^\((.*)\)$/;
const ranges = ["\ud83c[\udf00-\udfff]",
// U+1F300 to U+1F3FF
"\ud83d[\udc00-\ude4f]",
// U+1F400 to U+1F64F
"\ud83d[\ude80-\udeff]", "/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g", "/([#0-9]\u20E3)|[\xA9\xAE\u203C\u2047-\u2049\u2122\u2139\u3030\u303D\u3297\u3299][\uFE00-\uFEFF]?|[\u2190-\u21FF][\uFE00-\uFEFF]?|[\u2300-\u23FF][\uFE00-\uFEFF]?|[\u2460-\u24FF][\uFE00-\uFEFF]?|[\u25A0-\u25FF][\uFE00-\uFEFF]?|[\u2600-\u27BF][\uFE00-\uFEFF]?|[\u2900-\u297F][\uFE00-\uFEFF]?|[\u2B00-\u2BF0][\uFE00-\uFEFF]?|(?:\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDEFF])[\uFE00-\uFEFF]?|[\u20E3]|[\u26A0-\u3000]|\uD83E[\udd00-\uddff]|[\u00A0-\u269F]/"];
const regex = new RegExp(ranges.join("|"), "g");
const removeSymbs = (str = "") => str.trim().replace(/[`*~¡!?()_|+\-=?¿;:'’",.<>\{\}\[\]\\\/]/gi, "");
const removeSymbolsFillInBlanks = (str = "") => str.trim().replace(/[!?;:,.\{\}\[\]\\\/]/gi, "");
const removeEmojis = (str = "") => str.replace(regex, "");
const containsInvalidSymbols = input => {
  const invalidChars = /[`#^*_\[\];\\|<>\/~]/; // !()@,.'$%&+={}?:"  allowed

  if (invalidChars.test(input)) {
    return true;
  }
  return false;
};
exports.containsInvalidSymbols = containsInvalidSymbols;
const removeExtraWhiteSpaces = (str = "") => str.replace(/\s+/g, " ").trim();
exports.removeExtraWhiteSpaces = removeExtraWhiteSpaces;
const removeAllSymbols = (str = "") => {
  const removedEmojis = removeEmojis(str);
  const removedSymbs = removeSymbs(removedEmojis);
  return removeExtraWhiteSpaces(removedSymbs).toString();
};
exports.removeAllSymbols = removeAllSymbols;
const removeAllSymbolsFillInBlanks = (str = "") => {
  const removedSymbs = removeSymbolsFillInBlanks(str);
  return removedSymbs.trim().toString();
};
exports.removeAllSymbolsFillInBlanks = removeAllSymbolsFillInBlanks;
const removeSymbols = (str = "") => str.trim().replace(/[`*~¡!?()_|+\-=?¿;:'’",.<>\{\}\[\]\\\/]/gi, "");
exports.removeSymbols = removeSymbols;
function shuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}
const jsonToRivescript = (json, rsConfig) => {
  const tempRS = new _rivescript.default(rsConfig);
  return tempRS.stringify(json);
};
exports.jsonToRivescript = jsonToRivescript;
const rivescriptToJson = (rs, rsConfig) => {
  const tempRS = new _rivescript.default(rsConfig);
  tempRS.stream(rs);
  tempRS.sortReplies();
  return tempRS.deparse();
};
exports.rivescriptToJson = rivescriptToJson;
const randomId = (min = 59999, max = 99999) => {
  const minA = Math.ceil(min);
  const maxA = Math.floor(max);
  return Math.floor(Math.random() * (maxA - minA + 1)) + minA;
};
exports.randomId = randomId;
const formatFileSize = fileSize => {
  const fileSizes = ["B", "KB", "MB", "GB", "TB", "PB"];
  let value = fileSize;
  for (let i = 0; i < fileSizes.length; i += 1) {
    if (value < 1000) {
      return `${value.toFixed(2)} ${fileSizes[parseInt(i)]}`;
    }
    value /= 1000;
  }
  return "";
};
exports.formatFileSize = formatFileSize;
const formatCourseMemberCompletions = (data = []) => {
  let formatted = {};
  data.forEach(item => {
    if (Object.prototype.hasOwnProperty.call(formatted, item.createdBy)) {
      formatted[`${item.createdBy}`].push(item);
    } else {
      formatted[`${item.createdBy}`] = [item];
    }
  });
  return formatted;
};
exports.formatCourseMemberCompletions = formatCourseMemberCompletions;
const getScoreValues = (type, id, completions) => {
  const invalidExercisesCorrectness = ["bot", "roleplay-story"];
  const validExercisesPronunciation = ["pronunciation", "bot", "speaking"];
  let totalAnswers = 0;
  let totalAnswersCorrect = 0;
  let pronunciationScoreCount = 0;
  let totalPronunciationScore = 0;
  let percentCorrect = {
    completed: 0,
    total: 0,
    percentage: 0
  };
  if (Array.isArray(completions)) {
    completions.forEach(c => {
      let idMatches = false;
      if (type === "course") {
        idMatches = id === c.courseId;
      } else if (type === "section") {
        idMatches = `${c.courseId}|${id}` === c.courseSectionId;
      } else if (type === "topic") {
        idMatches = `${c.courseSectionId}|${id}` === c.courseSectionTopicId;
      }
      if (idMatches) {
        if (!invalidExercisesCorrectness.includes(c.exercise)) {
          totalAnswers += c.totalAnswers;
          totalAnswersCorrect += c.totalAnswersCorrect;
        }
        if (validExercisesPronunciation.includes(c.exercise) && c.avgPronunciationScore !== -1) {
          totalPronunciationScore += c.avgPronunciationScore;
          pronunciationScoreCount++;
        }
      }
    });
  }
  percentCorrect.completed = totalAnswersCorrect;
  percentCorrect.total = totalAnswers;
  percentCorrect.percentage = totalAnswers > 0 ? Math.floor(totalAnswersCorrect / totalAnswers * 100) : 0;
  const avgPronunciationScore = pronunciationScoreCount > 0 ? Math.floor(totalPronunciationScore / pronunciationScoreCount) : -1;
  if (totalAnswers > 0) {
    return [percentCorrect, avgPronunciationScore];
  } else {
    return [{
      completed: 0,
      total: 0,
      percentage: 0
    }, avgPronunciationScore];
  }
};
exports.getScoreValues = getScoreValues;
const calcTopicCompletions = (topic, completions = [], isSectionHidden, assignmentExercises) => {
  let isRoleplaysHidden;
  let isPronunciationHidden;
  let isBotsHidden;
  let isListeningHidden;
  let isTranslationHidden;
  let isPhrases;
  let completedExerciseCount = 0;
  let totalExercises = 0;
  if (topic.phrases && topic.phrases.length > 0) {
    isPhrases = true;
  }
  if (isSectionHidden || topic.isTopicHidden) {
    isRoleplaysHidden = true;
    isBotsHidden = true;
    isPronunciationHidden = true;
    isListeningHidden = true;
    isTranslationHidden = true;
  } else if (assignmentExercises) {
    isPronunciationHidden = true;
    isListeningHidden = true;
    isTranslationHidden = true;
    assignmentExercises.forEach(e => {
      if (e.name === "pronunciation") {
        isPronunciationHidden = false;
      }
      if (e.name === "listening") {
        isListeningHidden = false;
      }
      if (e.name === "translation") {
        isTranslationHidden = false;
      }
    });
  } else if (topic && topic.hiddenExercises) {
    topic.hiddenExercises.forEach(exercise => {
      if (exercise === "roleplays") {
        isRoleplaysHidden = true;
      }
      if (exercise === "chatbots") {
        isBotsHidden = true;
      }
      if (exercise === "pronunciation") {
        isPronunciationHidden = true;
      }
      if (exercise === "listening") {
        isListeningHidden = true;
      }
      if (exercise === "translation") {
        isTranslationHidden = true;
      }
    });
  }
  if (isPhrases) {
    if (!isPronunciationHidden) {
      totalExercises++;
    }
    if (!isListeningHidden) {
      totalExercises++;
    }
    if (!isTranslationHidden) {
      totalExercises++;
    }
  }
  const completedPronunciation = Array.isArray(completions) ? completions.filter(c => c.topicId === topic.topicId && c.exercise === "pronunciation").length : 0;
  const completedTranslation = Array.isArray(completions) ? completions.filter(c => c.topicId === topic.topicId && c.exercise === "translation").length : 0;
  const completedListening = Array.isArray(completions) ? completions.filter(c => c.topicId === topic.topicId && c.exercise === "listening").length : 0;
  completedExerciseCount += !isPronunciationHidden && completedPronunciation > 0 ? 1 : 0;
  completedExerciseCount += !isTranslationHidden && completedTranslation > 0 ? 1 : 0;
  completedExerciseCount += !isListeningHidden && completedListening > 0 ? 1 : 0;
  let completedRoleplays = 0;
  let completedGames = 0;
  let totalNumberOfGames = 0;
  let completedBots = 0;
  const roleplays = topic.roleplays.map(roleplay => {
    const {
      isActItOutHidden = false,
      isActItOutListeningHidden = false,
      isActItOutListeningSpeakingHidden = false,
      isActItOutSpeakingHidden = false
    } = roleplay;
    const trueCount = Object.values({
      isActItOutHidden,
      isActItOutListeningHidden,
      isActItOutListeningSpeakingHidden,
      isActItOutSpeakingHidden
    }).filter(Boolean).length;
    const numberOfUnhiddenGames = 6 - trueCount;
    const isUnassignedRoleplay = assignmentExercises ? assignmentExercises && !assignmentExercises.some(e => e.roleplayId === roleplay.roleplayId) : false;
    if (isRoleplaysHidden || roleplay.isRoleplayHidden || isSectionHidden || topic.isTopicHidden || isUnassignedRoleplay) {
      return {
        ...roleplay,
        completedCount: 0
      };
    }
    const uniqueCompletions = Array.isArray(completions) ? Array.from(new Map(completions.filter(completion => completion.roleplayId === roleplay.roleplayId).map(completion => [completion.exercise, completion])).values()) : [];
    completedGames += uniqueCompletions.length;
    totalNumberOfGames += numberOfUnhiddenGames;
    if (uniqueCompletions?.length === numberOfUnhiddenGames) {
      completedRoleplays++;
    }
    completedExerciseCount += uniqueCompletions.length;
    totalExercises += numberOfUnhiddenGames;
    return {
      ...roleplay,
      completedCount: uniqueCompletions.length
    };
  });
  const bots = topic.bots.map(bot => {
    const isUnassignedBot = assignmentExercises ? assignmentExercises && !assignmentExercises.some(e => e.botId === bot.botId) : false;
    if (isBotsHidden || bot.isBotHidden || isSectionHidden || topic.isTopicHidden || isUnassignedBot) {
      return {
        ...bot,
        completedCount: 0
      };
    }
    const completedCount = Array.isArray(completions) ? completions.reduce((acc, completion) => {
      if (completion && completion.exercise === "bot" && completion.botId === bot.botId) {
        acc++;
      }
      return acc;
    }, 0) : 0;
    if (completedCount > 0) {
      completedBots++;
      completedExerciseCount++;
    }
    totalExercises++;
    return {
      ...bot,
      completedCount
    };
  });
  const scoreValues = getScoreValues("topic", topic.topicId, completions);
  return {
    ...topic,
    roleplays,
    bots,
    completion: {
      completed: completedExerciseCount,
      total: totalExercises,
      percentage: Math.floor(completedExerciseCount / totalExercises * 100),
      pronunciation: {
        completedCount: completedPronunciation
      },
      translation: {
        completedCount: completedTranslation
      },
      listening: {
        completedCount: completedListening
      },
      roleplays: {
        completed: completedRoleplays,
        completedCount: roleplays.map(roleplay => [roleplay.roleplayId, roleplay.completedCount]),
        total: roleplays.length,
        percentage: Math.floor(completedGames / totalNumberOfGames * 100)
      },
      bots: {
        completed: completedBots,
        total: bots.length,
        percentage: Math.floor(completedBots / bots.length * 100)
      }
    },
    percentCorrect: scoreValues[0],
    avgPronunciationScore: {
      percentage: scoreValues[1]
    }
  };
};
exports.calcTopicCompletions = calcTopicCompletions;
const calcCompletions = (sections = [], completions = [], assignmentExercises) => sections.map(section => {
  const topics = section.topics.map(topic => {
    return calcTopicCompletions(topic, completions, section.isHidden, assignmentExercises?.filter(e => e.courseSectionTopicId === `${topic.courseSectionId}|${topic.topicId}`));
  });
  const sectionExerciseCount = topics.reduce((currentValue, topic) => topic.completion.total + currentValue, 0);
  const sectionCompletedExerciseCount = topics.reduce((currentValue, topic) => topic.completion.completed + currentValue, 0);
  if (section.isHidden) {
    return {
      ...section,
      completion: {
        completed: 0,
        total: 0,
        percentage: 0
      },
      percentCorrect: {
        completed: 0,
        total: 0,
        percentage: 0
      },
      avgPronunciationScore: {
        percentage: -1
      },
      topics
    };
  }
  const scoreValues = getScoreValues("section", section.sectionId, completions);
  return {
    ...section,
    completion: {
      completed: sectionCompletedExerciseCount,
      total: sectionExerciseCount,
      percentage: Math.floor(sectionCompletedExerciseCount / sectionExerciseCount * 100)
    },
    percentCorrect: scoreValues[0],
    avgPronunciationScore: {
      percentage: scoreValues[1]
    },
    topics
  };
});
exports.calcCompletions = calcCompletions;
const calcPercentageCompletion = (sections = []) => {
  const result = sections.reduce((c, section) => {
    if (c && section && section.completion) {
      c.completed += section.completion.completed;
      c.total += section.completion.total;
      c.percentage = Math.floor(c.completed / c.total * 100);
    }
    c.completed = Math.round(c.completed);
    c.total = Math.round(c.total);
    c.percentage = Math.round(c.percentage);
    return c;
  }, {
    completed: 0,
    total: 0,
    percentage: 0
  });
  return result;
};

/**
 * Compares an array from old and new props between renders. Used as the validation
 * function when using `memo()` on a component
 * @param prevProps
 * @param nextProps
 * @param key The array to compare props e.g. roleplays, courses
 * @param idField The unique object ID of an object e.g. courseId, roleplayId
 * @returns {this is *[]|boolean}
 */
exports.calcPercentageCompletion = calcPercentageCompletion;
const propsAreEqual = (prevProps, nextProps, key, idField) => {
  const oldPropsArray = prevProps[key] || [];
  const newPropsArray = nextProps[key] || [];
  if (oldPropsArray.length !== newPropsArray.length) {
    return false;
  } else {
    return newPropsArray.every(newArrayObject => {
      const foundOldObject = oldPropsArray.find(oldCourse => oldCourse[idField] === newArrayObject[idField]);
      if (!foundOldObject) {
        return false;
      } else {
        const isEqual = (0, _deepEqual.default)(foundOldObject, newArrayObject);
        if (!isEqual) {
          return false;
        }
      }
      return true;
    });
  }
};
exports.propsAreEqual = propsAreEqual;
async function getBase64ImageFromUrl(imageUrl) {
  const res = await fetch(imageUrl);
  const blob = await res.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener("load", function () {
      resolve(reader.result);
    }, false);
    reader.onerror = () => {
      return reject(this);
    };
    reader.readAsDataURL(blob);
  });
}
const formatMarkdownNewlines = line => {
  return line;
  // Temp disable this feature -
  // Causes some issues with matching correct answers and text highlighting during tts
  // const split = line.split('\n').map((item) => item.trim());
  // return split.join('  \n');
};
exports.formatMarkdownNewlines = formatMarkdownNewlines;
function moveDecimal(number, decimalPlace) {
  if (decimalPlace === 0) return number;
  return number / Math.pow(10, decimalPlace);
}
function formatCurrency(amountInCents, currency) {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency
  });
  const decimalAmount = moveDecimal(amountInCents, _currencyCodeMap.default[currency.toUpperCase()].decimal_digits);
  return formatter.format(decimalAmount);
}
const localeCompare = (a, b) => a.localeCompare(b, undefined, {
  sensitivity: "base"
});
exports.localeCompare = localeCompare;
const localeCompareCase = (a, b) => a.localeCompare(b, undefined, {
  sensitivity: "case"
});
exports.localeCompareCase = localeCompareCase;
const domainPattern = exports.domainPattern = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/i;
const validateDomain = (domain = "") => {
  const result = domain.match(domainPattern);
  return result && result[0] === result.input;
};
exports.validateDomain = validateDomain;
const supportsAudioType = type => {
  let audio;

  // Allow user to create shortcuts, i.e. just "mp3"
  let formats = {
    mp3: "audio/mpeg",
    mp4: "audio/mp4",
    aif: "audio/x-aiff",
    ogg: "audio/ogg"
  };
  if (!audio) {
    audio = document.createElement("audio");
  }
  return audio.canPlayType(formats[type] || type);
};
exports.supportsAudioType = supportsAudioType;
const replaceWordWithBlank = (blank, currentString) => {
  let newString = currentString.replace(blank, "_____");
  return newString;
};
exports.replaceWordWithBlank = replaceWordWithBlank;
const formatNumberTotal = n => {
  if (!n) return 0;
  if (n < 1e3) return n;
  if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + "K";
  if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + "M";
  if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + "B";
  if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T";
};
exports.formatNumberTotal = formatNumberTotal;
const checkIsGeneratedEmail = email => (email || "").endsWith("-generated@waysidepublishing.com");
exports.checkIsGeneratedEmail = checkIsGeneratedEmail;
const objToSearchString = obj => {
  if (!obj) {
    return "";
  }
  // Create a new object with only non-empty properties
  const filteredObj = Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== "" && value !== null && value !== undefined));

  // Then use this new object to create URLSearchParams
  return new URLSearchParams(filteredObj).toString();
};
exports.objToSearchString = objToSearchString;
const searchStringToObj = searchString => {
  if (!searchString) {
    return {};
  }
  return Object.fromEntries(new URLSearchParams(searchString));
};
exports.searchStringToObj = searchStringToObj;
const getBrowserInfo = userAgent => {
  let browser = "Other";
  if (userAgent.includes("Firefox")) {
    browser = "Mozilla Firefox";
  } else if (userAgent.includes("SamsungBrowser")) {
    browser = "Samsung Internet";
  } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
    browser = "Opera";
  } else if (userAgent.includes("Edge")) {
    browser = "Microsoft Edge (Legacy)";
  } else if (userAgent.includes("Edg")) {
    browser = "Microsoft Edge (Chromium)";
  } else if (userAgent.includes("Chrome")) {
    browser = "Google Chrome or Chromium";
  } else if (userAgent.includes("Safari")) {
    browser = "Apple Safari";
  }
  return browser;
};
exports.getBrowserInfo = getBrowserInfo;
const getMachineInfo = userAgent => {
  let machineInfo = "Not found";
  const regex = /\(([^)]+)\)/;
  const matches = userAgent.match(regex);
  if (matches?.length > 1) {
    machineInfo = matches[1];
  }
  return machineInfo;
};
exports.getMachineInfo = getMachineInfo;
const getMicrophoneInfo = async mediaDevices => {
  try {
    await mediaDevices.getUserMedia({
      audio: true
    });
    const devices = await mediaDevices.enumerateDevices();
    const microphones = devices?.filter(device => device.kind === "audioinput");
    const availableMicrophoneNames = microphones?.filter(device => device.deviceId !== "default").map(device => device.label).join(", ") || "No available microphones detected";
    const activeMicrophone = microphones?.length > 0 ? microphones.find(mic => mic.deviceId === "default") || microphones[0] : null;
    const activeMicrophoneName = activeMicrophone?.label.split("Default - ").pop() || "No active microphone detected";
    return [availableMicrophoneNames, activeMicrophoneName];
  } catch (error) {
    console.error("Error accessing the microphone:", error);
  }
};
exports.getMicrophoneInfo = getMicrophoneInfo;
const downsampleBuffer = (buffer, sampleRate, outSampleRate) => {
  if (outSampleRate == sampleRate) {
    return buffer;
  }
  if (outSampleRate > sampleRate) {
    throw new Error("downsampling rate show be smaller than original sample rate");
  }
  var sampleRateRatio = sampleRate / outSampleRate;
  var newLength = Math.round(buffer.length / sampleRateRatio);
  var result = new Int16Array(newLength);
  var offsetResult = 0;
  var offsetBuffer = 0;
  while (offsetResult < result.length) {
    var nextOffsetBuffer = Math.round((offsetResult + 1) * sampleRateRatio);
    var accum = 0,
      count = 0;
    for (var i = offsetBuffer; i < nextOffsetBuffer && i < buffer.length; i += 1) {
      accum += buffer[i];
      count += 1;
    }
    result[offsetResult] = Math.min(1, accum / count) * 0x7fff;
    offsetResult += 1;
    offsetBuffer = nextOffsetBuffer;
  }
  return result.buffer;
};
exports.downsampleBuffer = downsampleBuffer;